export const notifications = {
  // Email subject lines
  subjects: {
    projectCreated: 'Új projekt létrehozva: {{projectName}}',
    projectUpdated: 'Projekt frissítve: {{projectName}}',
    projectStatusChanged: 'Projekt státusz változott: {{projectName}}',
    projectAssigned: 'Új projekt hozzárendelve: {{projectName}}',
    projectCompleted: 'Projekt befejezett: {{projectName}}',
    
    taskCreated: 'Új feladat létrehozva: {{taskTitle}}',
    taskUpdated: 'Feladat frissítve: {{taskTitle}}',
    taskAssigned: 'Új feladat hozzárendelve: {{taskTitle}}',
    taskStatusChanged: 'Feladat státusz változott: {{taskTitle}}',
    taskCompleted: 'Feladat befejezett: {{taskTitle}}',
    taskOverdue: 'Feladat lejárt: {{taskTitle}}',
    taskDueSoon: 'Feladat hamarosan lejár: {{taskTitle}}',
    
    customerCreated: 'Új ügyfél létrehozva: {{customerName}}',
    customerStatusChanged: 'Ügyfél státusz változott: {{customerName}}',
    customerDataUpdated: 'Ügyfél adatai módosultak: {{customerName}}',
    
    quotationCreated: 'Új ajánlat létrehozva: {{quotationNumber}}',
    quotationStatusChanged: 'Ajánlat státusz változott: {{quotationNumber}}',
    
    dealCreated: 'Új interakció rögzítve',
    dealStatusChanged: 'Interakció státusz változott',
    
    contractCreated: 'Új szerződés létrehozva: {{contractName}}',
    contractStatusChanged: 'Szerződés státusz változott: {{contractName}}',
    
    organizationCreated: 'Új szervezet létrehozva: {{organizationName}}',
    organizationUpdated: 'Szervezet adatai frissültek: {{organizationName}}',
    organizationDeleted: 'Szervezet törölve: {{organizationName}}',
    
    userAdded: 'Hozzáadtak egy szervezethez',
    userRemoved: 'Eltávolítottak egy szervezetből',
    permissionsChanged: 'Jogosultságaid megváltoztak',
    
    welcomeToOrganization: 'Üdvözöljük a {{organizationName}} szervezetben!',
    userInvitation: 'Meghívó a {{organizationName}} szervezetbe',
    accountActivated: 'Fiók aktiválva',
    roleChanged: 'Szerepkör módosítva'
  },

  // Email messages
  messages: {
    // Project notifications
    projectCreated: `
      <p>Kedves {{userName}}!</p>
      <p>Új projekt lett létrehozva a rendszerben:</p>
      <h3>{{projectName}}</h3>
      <p><strong>Leírás:</strong> {{projectDescription}}</p>
      <p><strong>Kezdési dátum:</strong> {{startDate}}</p>
      <p><strong>Befejezési dátum:</strong> {{endDate}}</p>
      <p><strong>Prioritás:</strong> {{priority}}</p>
      <p><strong>Létrehozó:</strong> {{createdBy}}</p>
      <p>A projekt részletei megtekinthetők a rendszerben.</p>
    `,
    
    projectUpdated: `
      <p>Kedves {{userName}}!</p>
      <p>A következő projekt frissítésre került:</p>
      <h3>{{projectName}}</h3>
      <p><strong>Módosítások:</strong></p>
      <ul>{{changes}}</ul>
      <p><strong>Módosította:</strong> {{updatedBy}}</p>
      <p>A projekt részletei megtekinthetők a rendszerben.</p>
    `,
    
    projectStatusChanged: `
      <p>Kedves {{userName}}!</p>
      <p>A következő projekt státusza megváltozott:</p>
      <h3>{{projectName}}</h3>
      <p><strong>Új státusz:</strong> {{newStatus}}</p>
      <p><strong>Korábbi státusz:</strong> {{oldStatus}}</p>
      <p><strong>Módosította:</strong> {{changedBy}}</p>
      <p>A projekt részletei megtekinthetők a rendszerben.</p>
    `,
    
    projectAssigned: `
      <p>Kedves {{userName}}!</p>
      <p>Ön hozzá lett rendelve a következő projekthez:</p>
      <h3>{{projectName}}</h3>
      <p><strong>Leírás:</strong> {{projectDescription}}</p>
      <p><strong>Befejezési dátum:</strong> {{endDate}}</p>
      <p><strong>Prioritás:</strong> {{priority}}</p>
      <p><strong>Hozzárendelte:</strong> {{assignedBy}}</p>
      <p>Kérjük, tekintse meg a projekt részleteit a rendszerben.</p>
    `,
    
    projectCompleted: `
      <p>Kedves {{userName}}!</p>
      <p>A következő projekt sikeresen befejezésre került:</p>
      <h3>{{projectName}}</h3>
      <p><strong>Befejezési dátum:</strong> {{completionDate}}</p>
      <p><strong>Végső progress:</strong> {{finalProgress}}%</p>
      <p><strong>Befejező:</strong> {{completedBy}}</p>
      <p>Gratulálunk a sikeres projekt befejezéséhez!</p>
    `,

    // Task notifications
    taskCreated: `
      <p>Kedves {{userName}}!</p>
      <p>Új feladat lett létrehozva{{#if projectName}} a "{{projectName}}" projektben{{/if}}:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Leírás:</strong> {{taskDescription}}</p>
      <p><strong>Prioritás:</strong> {{priority}}</p>
      <p><strong>Határidő:</strong> {{dueDate}}</p>
      <p><strong>Létrehozó:</strong> {{createdBy}}</p>
      <p>A feladat részletei megtekinthetők a rendszerben.</p>
    `,
    
    taskUpdated: `
      <p>Kedves {{userName}}!</p>
      <p>A következő feladat frissítésre került:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Módosítások:</strong></p>
      <ul>{{changes}}</ul>
      <p><strong>Módosította:</strong> {{updatedBy}}</p>
      <p>A feladat részletei megtekinthetők a rendszerben.</p>
    `,
    
    taskAssigned: `
      <p>Kedves {{userName}}!</p>
      <p>Ön hozzá lett rendelve a következő feladathoz:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Leírás:</strong> {{taskDescription}}</p>
      <p><strong>Prioritás:</strong> {{priority}}</p>
      <p><strong>Határidő:</strong> {{dueDate}}</p>
      {{#if projectName}}<p><strong>Projekt:</strong> {{projectName}}</p>{{/if}}
      <p><strong>Hozzárendelte:</strong> {{assignedBy}}</p>
      <p>Kérjük, tekintse meg a feladat részleteit a rendszerben.</p>
    `,
    
    taskStatusChanged: `
      <p>Kedves {{userName}}!</p>
      <p>A következő feladat státusza megváltozott:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Új státusz:</strong> {{newStatus}}</p>
      <p><strong>Korábbi státusz:</strong> {{oldStatus}}</p>
      <p><strong>Módosította:</strong> {{changedBy}}</p>
      <p>A feladat részletei megtekinthetők a rendszerben.</p>
    `,
    
    taskCompleted: `
      <p>Kedves {{userName}}!</p>
      <p>A következő feladat sikeresen befejezésre került:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Befejezési dátum:</strong> {{completionDate}}</p>
      {{#if actualHours}}<p><strong>Ráfordított idő:</strong> {{actualHours}} óra</p>{{/if}}
      <p><strong>Befejező:</strong> {{completedBy}}</p>
      <p>Gratulálunk a sikeres feladat befejezéséhez!</p>
    `,
    
    taskOverdue: `
      <p>Kedves {{userName}}!</p>
      <p>⚠️ A következő feladat határideje lejárt:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Határidő volt:</strong> {{dueDate}}</p>
      <p><strong>Lejárt:</strong> {{daysOverdue}} nappal ezelőtt</p>
      <p><strong>Prioritás:</strong> {{priority}}</p>
      {{#if assignedTo}}<p><strong>Felelős:</strong> {{assignedTo}}</p>{{/if}}
      <p>Kérjük, intézkedjen a feladat mielőbbi befejezése érdekében.</p>
    `,
    
    taskDueSoon: `
      <p>Kedves {{userName}}!</p>
      <p>🕐 A következő feladat hamarosan lejár:</p>
      <h3>{{taskTitle}} ({{taskNumber}})</h3>
      <p><strong>Határidő:</strong> {{dueDate}}</p>
      <p><strong>Lejár:</strong> {{daysUntilDue}} nap múlva</p>
      <p><strong>Prioritás:</strong> {{priority}}</p>
      {{#if assignedTo}}<p><strong>Felelős:</strong> {{assignedTo}}</p>{{/if}}
      <p>Kérjük, ügyeljen a határidő betartására.</p>
    `,

    // User management notifications
    welcomeToOrganization: `
      <p>Kedves {{userName}}!</p>
      <p>Üdvözöljük a <strong>{{organizationName}}</strong> YouCRM rendszerében!</p>
      <p><strong>Az Ön adatai:</strong></p>
      <ul>
        <li><strong>Név:</strong> {{userName}}</li>
        <li><strong>Email:</strong> {{userEmail}}</li>
        <li><strong>Szerepkör:</strong> {{userRole}}</li>
        <li><strong>Szervezet:</strong> {{organizationName}}</li>
      </ul>
      <p>Most már teljes hozzáféréssel rendelkezik a rendszerhez a jogosultsági szintje szerint.</p>
      <p>Ha bármilyen kérdése van, keressen minket bizalommal.</p>
    `,
    
    userInvitation: `
      <p>Kedves {{userName}}!</p>
      <p>Meghívást kapott a <strong>{{organizationName}}</strong> YouCRM rendszerébe!</p>
      <p><strong>Meghívás részletei:</strong></p>
      <ul>
        <li><strong>Szervezet:</strong> {{organizationName}}</li>
        <li><strong>Szerepkör:</strong> {{userRole}}</li>
        <li><strong>Meghívó:</strong> {{invitedBy}}</li>
      </ul>
      <p>A meghívás elfogadásához és a fiók aktiválásához kérjük, jelentkezzen be a rendszerbe.</p>
    `,
    
    accountActivated: `
      <p>Kedves {{userName}}!</p>
      <p>Fiókja sikeresen aktiválásra került a <strong>{{organizationName}}</strong> YouCRM rendszerében.</p>
      <p>Most már teljes hozzáféréssel rendelkezik a rendszer összes funkciójához, amelyre jogosultsága van.</p>
      <p>Ha bármilyen kérdése van, keressen minket bizalommal.</p>
    `,
    
    roleChanged: `
      <p>Kedves {{userName}}!</p>
      <p>A <strong>{{organizationName}}</strong> rendszerében az Ön jogosultságai módosultak.</p>
      <p><strong>Korábbi szerepkör:</strong> {{oldRole}}</p>
      <p><strong>Új szerepkör:</strong> {{newRole}}</p>
      <p><strong>Módosította:</strong> {{changedBy}}</p>
      <p>A változások azonnal érvénybe léptek.</p>
    `
  },

  // Common email elements
  common: {
    greeting: 'Kedves {{userName}}!',
    signature: `
      <br>
      <p>Üdvözlettel,<br>
      <strong>{{organizationName}} csapata</strong></p>
    `,
    footer: `
      <hr style="border: 1px solid #eee; margin: 20px 0;">
      <p style="color: #666; font-size: 14px;">
        Ez az email a YouCRM rendszerből lett küldve.<br>
        <strong>{{organizationName}}</strong><br>
        Ha nem kívánja többé megkapni ezeket az értesítéseket, kérjük, vegye fel a kapcsolatot a rendszergazdával.
      </p>
    `,
    viewInSystem: 'Megtekintés a rendszerben',
    doNotReply: 'Ez egy automatikusan generált email. Kérjük, ne válaszoljon erre az üzenetre.'
  },

  // Status and priority translations
  statuses: {
    // Project statuses
    planning: 'Tervezés',
    active: 'Aktív',
    inactive: 'Inaktív',
    completed: 'Befejezett',
    paused: 'Szüneteltetve',
    cancelled: 'Megszakított',
    
    // Task statuses
    todo: 'Tennivaló',
    in_progress: 'Folyamatban',
    pending: 'Függőben',
    rejected: 'Elutasítva',
    
    // Quotation statuses
    draft: 'Piszkozat',
    sent: 'Elküldve',
    accepted: 'Elfogadva',
    expired: 'Lejárt',
    
    // Contract statuses
    valid: 'Érvényes'
  },
  
  // Field names for change tracking
  fields: {
    companyName: 'cégnév',
    name: 'név',
    email: 'email',
    phone: 'telefon',
    address: 'cím',
    taxNumber: 'adószám',
    notes: 'megjegyzés',
    status: 'státusz'
  },

  priorities: {
    low: 'Alacsony',
    medium: 'Közepes',
    high: 'Magas',
    urgent: 'Sürgős'
  },

  roles: {
    super_admin: 'Szuper Adminisztrátor',
    admin: 'Adminisztrátor',
    user: 'Felhasználó'
  },

  // UI fordítások az értesítési központhoz
  title: 'Értesítések',
  all: 'Összes',
  unread: 'Olvasatlan',
  markAllRead: 'Összes megjelölése olvasottként',
  clearAll: 'Összes törlése',
  viewAll: 'Összes megtekintése',
  noNotifications: 'Nincs értesítés',
  noUnread: 'Nincs olvasatlan értesítés',
  confirmClearAll: 'Biztosan törli az összes értesítést?',
  settings: 'Értesítési beállítások',
  types: {
    task_assigned: 'Feladat kijelölve',
    task_completed: 'Feladat befejezve',
    task_overdue: 'Feladat lejárt',
    project_update: 'Projekt frissítés',
    deadline_reminder: 'Határidő emlékeztető',
    system: 'Rendszer értesítés',
    mention: 'Megemlítés'
  }
}; 